module.exports = __webpack_public_path__ + "img/theme-moon-icon.126a5df4.svg";